// Components
import Head from "next/head"
// Libs
import { CacheProvider, EmotionCache } from "@emotion/react"
import type { ReactElement, ReactNode } from "react"
import type { NextPage, NextPageContext } from "next"
import type { AppProps } from "next/app"
import CssBaseline from "@mui/material/CssBaseline"
import { ThemeProvider } from "@mui/material/styles"
import createEmotionCache from "@styles/createEmotionCache"
import theme from "@utils/theme"
import { wrapper } from "../states/store"
import { appWithTranslation } from "next-i18next"
// Styles
import "@styles/globals.css"

export type NextPageWithLayout<P = {}, IP = P> = NextPage<P, IP> & {
  getLayout?: (page: ReactElement) => ReactNode
  ctx?: NextPageContext
}
interface MyAppProps extends AppProps {
  emotionCache?: EmotionCache
}

type AppPropsWithLayout = MyAppProps & {
  Component: NextPageWithLayout
}

// Client-side cache, shared for the whole session of the user in the browser.
const clientSideEmotionCache = createEmotionCache()

function MyApp(props: AppPropsWithLayout) {
  const { Component, emotionCache = clientSideEmotionCache, pageProps } = props
  const getLayout = Component.getLayout ?? ((page) => <>{page}</>)

  return (
    <>
      <Head>
        <meta charSet="utf-8" />
        <meta
          name="viewport"
          content="minimum-scale=1, initial-scale=1, width=device-width, shrink-to-fit=no, maximum-scale=5"
        />
      </Head>
      <CacheProvider value={emotionCache}>
        <ThemeProvider theme={theme}>
          {/* <I18nextProvider i18n={i18n}> */}
          {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
          <CssBaseline />
          {getLayout(<Component {...pageProps} />)}
          {/* </I18nextProvider> */}
        </ThemeProvider>
      </CacheProvider>
    </>
  )
}

export default wrapper.withRedux(appWithTranslation(MyApp))
